export default __webpack_public_path__ + "static/media/login-04.3e48a220.jpg";